/**
 * Cấu hình host API chính thức cho môi trường Deploy.
 */
export function getApiBaseUrl() {
   return "https://api.ototrunganh.com";
   // return "http://localhost:8686";
}
